export default __webpack_public_path__ + "static/media/securephone.d9a260bb.png";